declare let API_HREF: string;
// Dependencies
import axios from 'axios';
// import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React, { FC, ReactElement, useContext, useEffect } from 'react';
// Core & Lab
import Button from '@mui/material/Button';
// Actions
import {
    addSelection,
    setAdding,
    addCustomPictures,
    updateProgress,
    updatePicturesForm,
} from './redux/actions';
// Utils
import { PictureContext } from './utils/pictureContext';
// Types
import { AppState } from '../../reducers';
import { useShowError } from '../../functions/useShowError';
import { PictureLocale } from './objects/picture';

const PictureModalCreate: FC = (): ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // const { enqueueSnackbar } = useSnackbar();
    const showError = useShowError();
    const client_id = useSelector((state: AppState) => state.header.client_id);
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const adding = useSelector((state: AppState) => state.picture.adding);
    const pictures = useSelector((state: AppState) => state.picture.pictures_form);
    const selection = useSelector((state: AppState) => state.picture.selection);
    const pictureContext = useContext(PictureContext);

    const onCreate = () => {
        dispatch(setAdding(true));
        const progressByFile: { [key: number]: number } = {};
        
        pictures.forEach((picture, file_index) => {
            progressByFile[file_index] = 0;
            const request = new FormData();

            const localization: PictureLocale[] = [];

            Object.entries(picture.name_locales).forEach(([key, value]) => {
                localization.push({
                    locale: Number(key),
                    name: value
                });
            });

            request.append('localization', JSON.stringify(localization));

            request.append('name', picture.name_locales[Number(current_locale)] || picture.name || "");
            if (picture.alt) {
                request.append('alt', picture.alt);
            }

            if (picture.credits) {
                request.append('credits', picture.credits);
            }

            if (picture.description) {
                request.append('description', picture.description);
            }

            if (picture.picture_category !== null && picture.picture_category !== undefined) {
                request.append('picture_category', String(picture.picture_category));
            }

            request.append('image', picture.file);
            axios({
                method: 'POST',
                url: `${API_HREF}client/${client_id}/pictures/`,
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                },
                params: {
                    type: (picture?.type || 'PICTURE')
                },
                data: request,
                onUploadProgress: (progressEvent) => {
                    progressByFile[file_index] = (progressEvent.loaded / progressEvent.total) * 100;
                    const totalProgress = Object.values(progressByFile).reduce((a, b) => a + b, 0) / pictures.length;
                    dispatch(updateProgress(totalProgress));
                }
            }).then((response) => {
                dispatch(addSelection(response.data, picture.name));
            }).catch((error) => {
                delete progressByFile[file_index];
                dispatch(updatePicturesForm(pictures.filter((_, i) => i !== file_index)));
                showError(error);
            }).finally(() => {
                if (Object.keys(progressByFile).length === 0) {
                    dispatch(updateProgress(0));
                }
            });
        });
    };
    useEffect(() => {
        if (adding && pictures.length === 0) {
            dispatch(addCustomPictures(selection));
            // if (manual_accommodation !== null) {
            if (pictureContext.onChangePictures) {
                pictureContext.onChangePictures(selection);
            }
            // }
        }
    }, [adding, pictures]);
    return (
        <PictureContext.Consumer>
            {({ disabled }) => (
                <Button
                    onClick={onCreate}
                    disabled={
                        disabled ||
                        pictures.length === 0 && selection.length === 0
                    }
                >
                    {t('shared.validate-selection')}
                </Button>
            )}
        </PictureContext.Consumer>
    );
};

export default PictureModalCreate;
